import { render, staticRenderFns } from "./GlobalMsgModal.vue?vue&type=template&id=55bbf0a6&scoped=true"
import script from "./GlobalMsgModal.vue?vue&type=script&lang=js"
export * from "./GlobalMsgModal.vue?vue&type=script&lang=js"
import style0 from "./GlobalMsgModal.vue?vue&type=style&index=0&id=55bbf0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbf0a6",
  null
  
)

export default component.exports